export default {
  UNKNOWN: 0,
  INVALID_TOKEN: 1,
  EXPIRED_TOKEN: 2,
  SUCCESS: 3,
};
